export default "/images/speaker.svg?d25c73d4e8d4693ec89eab6d8600cb9b";